import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cart/reducer";
import packageReducer from "./packages/reducer";
import currencyReducer from "./currency/reducer";
import featureReducer from "./features/reducer";
import cmsBlockReducer from "./cmsBlock/reducer";
import storeConfigReducer from "./storeConfig/reducer";
import categoryInfoReducer from "./category/reducer";
import faqReducer from "./faq/reducer";
import locationReducer from "./locations/reducer";
import notificationReducer from "./notification/reducer";

const store = configureStore({
  reducer: {
    cart: cartReducer,
    package: packageReducer,
    currency: currencyReducer,
    features: featureReducer,
    cmsBlock: cmsBlockReducer,
    storeConfig: storeConfigReducer,
    categoryInfo: categoryInfoReducer,
    faq: faqReducer,
    location: locationReducer,
    notification: notificationReducer,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
